import React from "react";
import { Button } from "reactstrap";
function JobToggle({ id, isVerified, jobTitleName, submit }) {
  return (
    <div>
      <Button
        color={isVerified ? "primary" : "danger"}
        className={isVerified ? "pe-4 btn-sm" : "btn-sm"}
        onClick={() =>
          submit({
            jobTitleId: id,
            jobTitleName: jobTitleName,
            isVerified: !isVerified,
          })
        }
      >
        {isVerified ? "Is Verified" : "Not Verified"}
      </Button>
    </div>
  );
}

export default JobToggle;
